import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Alert from "sweetalert-react";
import Loading from "../../../../components/Loading";
import * as Http from "../../../../http";
import * as Business from "../../../../utils/business";

export default class ReportChild extends Component {
  state = {
    items: [],
    loading: true,
    isShow: false,
    showFileDownloadError: false,
    failedDownloadsList: [],
  };

  getReportList = () => {
    Http.getListReport(
      Business.COMPONENT.RAROC,
      this.props.report.file_name,
    ).then((data) => {
      const lstReports = [];
      if (data && data.Success && data.Data) {
        data.Data.forEach((item) => {
          item.created = Business.convertToFullDate(item.created);
          lstReports.push(item);
        });
      }
      this.setState({ items: lstReports, loading: false });
    });
  };

  onSaveAllFiles = async () => {
    if (this.state.items && this.state.items.length > 0) {
      const fileArr = [];
      for (let i = 0; i < this.state.items.length; i++) {
        const fileInfo = Http.makeDownloadFileInfo(
          this.state.items[i].report_name,
          this.props.report.report_date,
          this.props.report.file_name,
          null,
          Business.COMPONENT.RAROC,
        );
        fileArr.push(fileInfo);
      }
      Http.downloadAllFiles(
        fileArr,
        this.props.report.report_date,
        this.props.report.file_name,
      ).then((result) => {
        if (result.is_error) {
          this.setState({
            showFileDownloadError: true,
            failedDownloadsList: result.failed_files,
          });
        }
      });
    }
  };

  show = () => {
    this.setState({
      isShow: true,
      loading: true,
    });
    this.getReportList();
  };

  close = () => {
    this.setState({
      isShow: false,
    });
  };

  renderContent = (items) => {
    const firstItem = items[0];
    const prefix = firstItem ? firstItem.report_name.split("_")[0] || "" : "";
    const SAMPLE_REPORTS = [
      { label: "Customer Report", fileName: "Customer_Report.xlsx" },
      { label: "Org-unit Report", fileName: "Org-unit_Report.xlsx" },
      { label: "Product Report", fileName: "Product_Report.xlsx" },
    ];
    return (
      <Modal.Body>
        {prefix && <div className="report-prefix-badge">{prefix}</div>}
        <div className="report-detail-list">
          {items.map((item) => {
            const nameWithoutExt = item.report_name.replace(/\.[^.]+$/, "");
            const typePart = prefix
              ? nameWithoutExt.substring(prefix.length + 1)
              : nameWithoutExt;
            return (
              <div className="report-detail-item" key={item.report_name}>
                <span className="report-detail-name">{typePart}</span>
                <div className="report-detail-actions">
                  <button
                    className="report-dl-btn report-dl-xlsx"
                    onClick={() =>
                      Http.downloadFile(
                        item.report_name,
                        this.props.report.report_date,
                        this.props.report.file_name,
                        null,
                        Business.COMPONENT.RAROC,
                      )
                    }
                  >
                    <i className="pe-7s-download" /> Download
                  </button>
                </div>
              </div>
            );
          })}
        </div>
        <div className="report-detail-footer">
          <button
            type="button"
            className="btn btn-primary report-save-all-btn"
            onClick={this.onSaveAllFiles}
          >
            <i className="pe-7s-download" /> SAVE ALL FILES
          </button>
        </div>
        <div
          style={{
            borderTop: "1px solid #e0e0e0",
            marginTop: 16,
            paddingTop: 12,
          }}
        >
          <div
            style={{
              fontWeight: 600,
              fontSize: 13,
              marginBottom: 8,
              color: "#444",
            }}
          >
            Standard Reports
          </div>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            {SAMPLE_REPORTS.map((report) => (
              <button
                key={report.fileName}
                type="button"
                className="btn btn-primary"
                style={{
                  backgroundColor: "#FFE600",
                  borderColor: "#7F7E82",
                  borderRadius: 20,
                  fontWeight: 600,
                  fontSize: 12,
                  padding: "6px 16px",
                  color: "#1a1a3e",
                }}
                onClick={() =>
                  Http.downloadSampleFile(report.fileName, "SAMPLE")
                }
              >
                ⬇ {report.label}
              </button>
            ))}
          </div>
        </div>
      </Modal.Body>
    );
  };

  renderLoading = () => (
    <div>
      <div style={{ height: 60 }}>
        <Loading size="small" />
      </div>
      <div style={{ height: 30 }} />
    </div>
  );

  render() {
    const { items } = this.state;

    return (
      <div>
        <a
          href="#url"
          style={{ color: "blue" }}
          onClick={(e) => {
            e.preventDefault();
            this.show();
          }}
        >
          {this.props.report.file_name}
        </a>
        <Modal show={this.state.isShow} onHide={this.close}>
          <Modal.Header closeButton>
            <Modal.Title>{this.props.report.file_name}</Modal.Title>
          </Modal.Header>
          {this.state.loading
            ? this.renderLoading()
            : this.renderContent(items)}
        </Modal>
        <Alert
          title="Some Files Failed to Download!"
          text={`Please check the following files: ${this.state.failedDownloadsList.join(", ")}`}
          show={this.state.showFileDownloadError}
          onConfirm={() => {
            this.setState({ showFileDownloadError: false });
          }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/pages/Raroc/Report/Reports/ReportChild.js